var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _circle, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNetNothing = function SvgNetNothing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 120 120"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#netNothing_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F2",
    d: "M110.184 74.192c1.744 1.755 3.439 3.578 5.261 5.255 1.182 1.091 1.201 1.813 0 2.963-7.732 7.41-16.53 13.162-26.567 16.789-25.627 9.272-49.994 6.493-72.889-8.316-3.798-2.457-7.092-5.713-10.629-8.57-1.114-.907-1.153-1.628-.077-2.671 3.73-3.656 7.392-7.38 11.045-11.115.97-.975 1.638-1.101 2.723-.068 7.848 7.41 16.975 12.538 27.497 14.839 20.191 4.426 38.26-.088 53.986-13.669 2.732-2.36 2.693-2.398 5.222.127l4.418 4.445z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "netNothing_svg__b",
    width: 208,
    height: 113,
    x: -48,
    y: -8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F2",
    d: "M60.31 104.616c-25.07 0-43.704-12.196-48.786-16.94L-48 37.492 60.31-8 159.2 32l-48.746 54.999c-16.601 14.229-40.316 17.617-50.142 17.617"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#netNothing_svg__b)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 105.5,
    fill: "#D4D9E2",
    opacity: 0.5,
    rx: 41,
    ry: 6.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D3D8E4",
    d: "M78.537 34.236a12.2 12.2 0 0 1 7.188 3.489c1.95 1.95 3.1 4.4 3.454 6.936l.06.508v.004c.038.423-.104.83-.377 1.14-.284.322-.694.5-1.114.5h-.428a1.21 1.21 0 0 1-1.183-1.119 9.05 9.05 0 0 0-2.631-5.76 9.03 9.03 0 0 0-5.632-2.622l-.006-.002a1.5 1.5 0 0 1-1.182-.785c.688-.699 1.31-1.465 1.851-2.289m2.3-10.443a22.8 22.8 0 0 1 12.426 6.383c4.19 4.182 6.411 9.604 6.673 15.094a1.46 1.46 0 0 1-1.458 1.542h-.177c-.801 0-1.454-.625-1.493-1.417l-.027-.445a19.68 19.68 0 0 0-5.727-12.556 19.64 19.64 0 0 0-10.088-5.393q.034-.496.034-1-.002-1.126-.163-2.208m-.175 5.382a17.46 17.46 0 0 1 8.523 4.473l.3.291a17.54 17.54 0 0 1 5.066 10.888l.03.385v.002c.024.414-.116.81-.395 1.115l-.007.009a1.5 1.5 0 0 1-1.091.468h-.425a1.193 1.193 0 0 1-1.195-1.139l-.045-.647a14.36 14.36 0 0 0-4.156-8.854 14.32 14.32 0 0 0-7.598-3.98 15 15 0 0 0 .993-3.011"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEB8C9",
    d: "M51.286 122.051H37.15c.036-.613 2.356-39.56 2.356-39.578h9.423c1.017 17.242.66 11.115 2.356 39.578"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#CACED7",
    d: "M56.94 122.049H31.497c.07-.39 4.244-25.427 4.244-25.443h16.956c1.851 11.071 1.187 7.143 4.243 25.443"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E7ED",
    d: "M56.939 122.049c-3.054-18.3-2.391-14.372-4.24-25.443h-8.482v25.443z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#6D9AE8",
    d: "M72.471 46.588 62.264 56.785l3.667 3.672L76.14 50.26z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEB8C9",
    d: "M75.235 45.842h-21.54v3.077h21.54z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEB8C9",
    d: "M76.772 47.38h-3.077v21.54h3.077z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#CACED7",
    d: "M55.526 81.057a9.886 9.886 0 0 1-9.895 9.894 9.886 9.886 0 0 1-9.894-9.894 9.886 9.886 0 0 1 9.894-9.895 9.886 9.886 0 0 1 9.895 9.895"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E7ED",
    d: "M41.7 80.842c12.925 12.93 33.898 12.93 46.84 0L41.7 34c-12.925 12.93-12.942 33.912 0 46.86z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#D3D8E4",
    d: "M88.54 80.96 65.322 58.03 41.894 81.165c12.952 12.567 33.765 12.498 46.629-.206z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "netNothing_svg__c",
    width: 57,
    height: 57,
    x: 32,
    y: 34,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E7ED",
    d: "M41.702 80.842c12.925 12.93 33.898 12.93 46.84 0L41.702 34c-12.925 12.93-12.942 33.912 0 46.86z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#netNothing_svg__c)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.18,
    cy: 67.184,
    fill: "#B9C2D1",
    opacity: 0.2,
    rx: 36.739,
    ry: 37.058,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "rotate(-44.671 83.18 67.184)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#D3D8E4",
    d: "M79.596 50.615a5.655 5.655 0 1 1-7.997-7.998 5.655 5.655 0 0 1 7.997 7.998"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3,
    cy: 10.3,
    r: 10.3,
    fill: "#F45149",
    transform: "matrix(-1 0 0 1 76.6 16)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.891 28.805v-.326q0-1.26.637-2.163.251-.356.548-.637t.711-.608q.445-.341.682-.577.237-.252.311-.534.044-.177.044-.355 0-.356-.207-.652a1.46 1.46 0 0 0-.533-.4 1.5 1.5 0 0 0-.682-.163q-.711 0-1.17.34-.43.342-.608 1.023l-.074.31-2.192-.562.074-.311q.37-1.467 1.363-2.222 1.006-.77 2.578-.77a4.6 4.6 0 0 1 1.555.251q.712.252 1.215.756.49.459.74 1.11.267.638.267 1.364 0 .622-.222 1.096a2.7 2.7 0 0 1-.518.8q-.297.326-.8.77-.667.563-.993 1.023-.31.444-.311 1.126v.326zm1.289 3.481q-.578 0-.993-.415-.4-.4-.4-1.007 0-.578.4-.978.416-.415.993-.415.578 0 .993.415.414.4.414.978 0 .577-.4 1.007a1.37 1.37 0 0 1-1.007.415"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.52,
    d: "m112.855 64.047-18.37 3.836M110.268 54.531 93.754 63.45M106.268 45 93.261 58.53"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "netNothing_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v120H0z"
  })))));
};
export default SvgNetNothing;